import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// Fügt CSS-Klassen zusammen (shadcn/ui-Muster):
//   clsx      – erlaubt Bedingungen: cn("a", isActive && "b")
//   twMerge   – löst Tailwind-Konflikte auf: cn("px-2", "px-4") -> "px-4"
// "...inputs" sammelt beliebig viele Argumente in einem Array (Rest-Parameter).
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
